import React from 'react'

const Span = ({children, ...props}) => React.createElement('span', props, children)

export default Span
